import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function BodyReliefCTASection() {
  return <section className="py-12 sm:py-16 md:py-20 bg-charcoal relative overflow-hidden text-center" data-id="element-161">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] sm:w-[600px] h-[400px] sm:h-[600px] bg-ginger opacity-10 rounded-full blur-[100px] pointer-events-none" data-id="element-162" />

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} data-id="element-164">
          <h2 className="text-ginger/60 font-light tracking-[0.2em] uppercase mb-3 sm:mb-4 text-xs" data-id="element-165">
            Why GINEXT Feels Different
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-bone mb-6 sm:mb-8 leading-relaxed px-4 font-light" data-id="element-166">
            Because it is.
            <br className="hidden sm:block" data-id="element-167" />
            <span className="text-white font-normal" data-id="element-168">
              Most products mask sensation. GINEXT supports circulation so
              pressure can release naturally.
            </span>
          </p>

          <div className="w-full h-px bg-white/10 mb-6 sm:mb-8" data-id="element-169" />

          <p className="text-sm sm:text-base text-gray-400 mb-2 sm:mb-3 font-light" data-id="element-170">
            That's the difference between covering pain — and helping your body
            feel better moving through the day.
          </p>

          <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-white mb-3 sm:mb-4 leading-tight tracking-tight" data-id="element-171">
            Feel the Warmth
            <br data-id="element-172" />
            <span className="text-ginger" data-id="element-173">Release the Pressure</span>
            <br data-id="element-174" />
            Move Freely Again
          </h2>

          <a href="#bundles" className="inline-block w-full sm:w-auto scroll-smooth mt-6 sm:mt-8" data-id="element-175">
            <motion.div whileHover={{
            scale: 1.05,
            boxShadow: '0 0 40px rgba(232, 119, 34, 0.5)'
          }} whileTap={{
            scale: 0.95
          }} className="w-full sm:w-auto group bg-ginger text-white px-6 sm:px-8 py-4 sm:py-5 rounded-lg font-light text-base sm:text-lg shadow-warm transition-all duration-300" data-id="element-176">
              <div className="flex items-center justify-center gap-2 mb-1" data-id="element-177">
                <span data-id="element-178">Try GINEXT Risk-Free</span>
                <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" data-id="element-179" />
              </div>
              <p className="text-xs sm:text-sm font-light text-white/90 text-center" data-id="element-180">
                30-Day Money-Back Guarantee
              </p>
            </motion.div>
          </a>

          <p className="mt-4 sm:mt-6 text-xs text-gray-500 font-light" data-id="element-181">
            Free Shipping Available
          </p>
        </motion.div>
      </div>
    </section>;
}